import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi, OrderArrowsUI } from '../Interface';
import projectTypeService from '../../service/projectType.service';

const ProjectTypeReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    projectTypeService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const orderProjectType = (id, newOrder) => {
    projectTypeService.orderProjectType(id, { newOrder }).then(() => {
      setRefetchTable(true);
    });
  };

  const handleOrderChange = (id, direction) => {
    orderProjectType(id, direction);
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      headerName: 'Megnevezés',
      type: 'string',
    },
    {
      field: 'active',
      headerName: 'Aktív',
      type: 'boolean',
    },
    {
      field: 'prefix',
      headerName: 'Prefix',
      type: 'string',
    },
    {
      field: 'visOrder',
      headerName: 'Sorrend',
      type: 'action',
      renderCell: (params) => {
        const disabled = params?.api?.getSortModel()[0]?.field !== 'visOrder';
        const isSortedDescending = params.api.getSortModel()[0]?.sort === 'desc';

        const handleUpClick = () => {
          if (isSortedDescending) {
            handleOrderChange(params.row.id, 'down');
          } else {
            handleOrderChange(params.row.id, 'up');
          }
        };

        const handleDownClick = () => {
          if (isSortedDescending) {
            handleOrderChange(params.row.id, 'up');
          } else {
            handleOrderChange(params.row.id, 'down');
          }
        };

        return <OrderArrowsUI onUpClick={handleUpClick} onDownClick={handleDownClick} disabled={disabled} />;
      },
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.ProjectType}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default ProjectTypeReports;
